/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentArtifactsControllerGetNutrientConfigQueryResponse, AgentArtifactsControllerGetNutrientConfigPathParams, AgentArtifactsControllerGetNutrientConfigQueryParams } from "../../models/agentArtifactsController/AgentArtifactsControllerGetNutrientConfig";

function getAgentArtifactsControllerGetNutrientConfigUrl(artifactId: AgentArtifactsControllerGetNutrientConfigPathParams["artifactId"]) {
  const res = { method: 'GET', url: `/api/v1/agent-artifacts/${artifactId}/nutrient-config` as const }  
  return res
}

/**
 * @description Uploads the artifact PDF to Nutrient Document Engine if needed, then returns a JWT and server URL for server-based viewing.
 * @summary Get Nutrient Document Engine config for an agent artifact PDF
 * {@link /api/v1/agent-artifacts/:artifactId/nutrient-config}
 */
export async function agentArtifactsControllerGetNutrientConfig(artifactId: AgentArtifactsControllerGetNutrientConfigPathParams["artifactId"], params: AgentArtifactsControllerGetNutrientConfigQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AgentArtifactsControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAgentArtifactsControllerGetNutrientConfigUrl(artifactId).url.toString(), params, ... requestConfig })  
  return res.data
}